function Contact() {
  return (
    <div className="contact shell">
      <h1>Have a project in mind?</h1>
      <p>We'd love to hear from you.</p>
      <a href="mailto:info@periscopeworks.io">info@periscopeworks.io</a>
    </div>
  );
}

export default Contact;
